import { TOPIC_CONTENT_SOURCES, type TopicContentSource } from "./topic-content-sources";

const sources = [
  {
    sourceId: "citizenship-source-conferral",
    topicId: "citizenship",
    title: "Become an Australian citizen by conferral - permanent resident",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/citizenship/become-a-citizen/permanent-resident",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 pathway URL과 갱신 메타데이터 확인; eligibility 상세본문은 동적 접근 제한",
    reviewStatus: "official_access_limited",
    claimScope: "permanent resident conferral pathway와 application 공식 시작점",
    followUp: "lodging 직전 eligibility, fee, documents와 exemptions를 직접 확인",
  },
  {
    sourceId: "citizenship-source-residence",
    topicId: "citizenship",
    title: "Residence Calculator",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/help-support/tools/residence-calculator",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 residence requirement, guide-only 제한과 입력 dates 확인",
    reviewStatus: "live_verified",
    claimScope: "lawful·permanent residence와 absences 계산",
    followUp: "current rule, exemptions·SCV rules와 Department records 재확인",
  },
  {
    sourceId: "citizenship-source-movement",
    topicId: "citizenship",
    title: "Requesting travel records",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/entering-and-leaving-australia/request-movement-records",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 movement records fields와 request path 확인",
    reviewStatus: "live_verified",
    claimScope: "residence calculation용 arrival·departure and visa evidence",
    followUp: "passport details와 requested period를 확인해 application과 대조",
  },
  {
    sourceId: "citizenship-source-test",
    topicId: "citizenship",
    title: "Citizenship test and interview",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/citizenship/test-and-interview",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 test·interview 대상과 assessment scope 확인",
    reviewStatus: "live_verified",
    claimScope: "citizenship test·interview 대상과 준비 시작점",
    followUp: "appointment notice의 documents, assistance와 arrangements 확인",
  },
] as const satisfies readonly TopicContentSource[];

const target = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of sources) if (!target.some((item) => item.sourceId === source.sourceId)) target.push(source);
